const faqToggle = () => {
  $('.c-faq-item').on('click', function () {
    $(this).toggleClass('is-open');
    $(this).find('.c-faq-item__answer').slideToggle();
  });
}

export default faqToggle;
